import { GameEventType } from "../../Types";
import { GameVars } from "../../GameVars";

export class BackgroundContainer extends Phaser.GameObjects.Container {

    private readonly background: Phaser.GameObjects.Image;
    private readonly darkOverlay: Phaser.GameObjects.Rectangle;

    constructor(scene: Phaser.Scene, private readonly gameplayEffects = true) {

        super(scene);

        const backgroundKey = GameVars.isLandscape ? "bg_1" : "bg_1_portrait";
        this.background = new Phaser.GameObjects.Image(
            this.scene,
            GameVars.gameWidth / 2,
            GameVars.gameHeight / 2,
            backgroundKey
        );

        if (!GameVars.isLandscape) {
            this.background.scaleY = GameVars.scaleY;
        }
        this.add(this.background);

        this.darkOverlay = new Phaser.GameObjects.Rectangle(
            this.scene,
            GameVars.gameWidth / 2,
            GameVars.gameHeight / 2,
            GameVars.gameWidth,
            GameVars.gameHeight,
            0x000000,
            .6
        );
        this.darkOverlay.alpha = gameplayEffects ? 1 : 0;
        this.add(this.darkOverlay);

        if (gameplayEffects) {
            this.scene.tweens.add({
                targets: this.darkOverlay,
                alpha: 0,
                duration: 1500,
                delay: 1500,
                ease: Phaser.Math.Easing.Cubic.Out
            });
            GameVars.eventsDispatcher.addEventListener(
                GameEventType.BIDDING_FINISHED, this.onBiddingFinished, this
            );
        }
    }

    public destroy(fromScene?: boolean): void {

        if (this.gameplayEffects) {
            GameVars.eventsDispatcher.removeEventListener(
                GameEventType.BIDDING_FINISHED, this.onBiddingFinished, this
            );
        }
        this.scene.tweens.killTweensOf(this.darkOverlay);
        super.destroy(fromScene);
    }

    private onBiddingFinished(): void {

        this.scene.tweens.killTweensOf(this.darkOverlay);
        this.scene.tweens.add({
            targets: this.darkOverlay,
            alpha: .6,
            duration: 500,
            ease: Phaser.Math.Easing.Cubic.Out
        });
    }

    public restoreAnimated(onComplete: () => void): void {

        this.scene.tweens.killTweensOf(this.darkOverlay);
        this.scene.tweens.add({
            targets: this.darkOverlay,
            alpha: 0,
            duration: 500,
            ease: Phaser.Math.Easing.Cubic.Out,
            onComplete
        });
    }

    public relayout(): void {

        this.background.scaleY = GameVars.isLandscape ? 1 : GameVars.scaleY;
    }
}
